const initAccordion = (item) => {
  const submenu = item.querySelector('[data-accordion-content]');

  if (submenu) {
    const link = item.querySelector('[data-accordion-trigger]');
    link.addEventListener('click', (e) => {
      e.preventDefault();
      item.classList.toggle('is-expanded');
    });

    document.body.addEventListener('click', (e) => {
      if (!item.contains(e.target)) {
        item.classList.remove('is-expanded');
      }
    });

    submenu.style.visibility = 'visible';
    submenu.style.height = 'auto';
    submenu.style.setProperty('--height', `${submenu.offsetHeight}px`);
    submenu.style.visibility = '';
    submenu.style.height = '';
  }
};

export default initAccordion;
